import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useRegisterContext } from "../../Contexts/RegisterContext";
import TermsConditionsModal from "../../Components/TermsConditions";
import PrivacyNoticeModal from "../../Components/PrivacyNotice";
import MemberConsentModal from "../../Components/MemberConsent";
import NumberField from "../../Components/NumberField";
import InputField from "../../Components/InputField";
import DatePicker from "../../Components/DatePicker";
import ErrorModal from "../../Components/ErrorModal";
import { resetConfig } from "../../utilities/helper";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import React, { useEffect } from "react";
import dayjs from "dayjs";
import UpdateModal from "./UpdateModal";

function ActivateCorpCodeFlow() {
  const {
    setShowTermsConditionModal,
    setShowMemberConsentModal,
    setShowPrivacyNoticeModal,
    employeeNumberValidation,
    setMemberConsentChecked,
    showTermsConditionModal,
    showMemberConsentModal,
    showPrivacyNoticeModal,
    setIsMiddleNameChecked,
    setConfirmEmailAddress,
    companyCodeValidation,
    setDisplayMemberExist,
    middleNameValidation,
    memberConsentChecked,
    isMiddleNameChecked,
    firstNameValidation,
    confirmEmailAddress,
    displayMemberExist,
    lastNameValidation,
    formatMobileNumber,
    isCorporateValid,
    suffixValidation,
    setDisplayAlert,
    setSelectedType,
    setTermsChecked,
    setAlertMessage,
    employeeNumber,
    setMiddleName,
    setAlertTitle,
    termsChecked,
    displayAlert,
    mobileNumber,
    setBirthDate,
    alertMessage,
    companyCode,
    suffixName,
    middleName,
    handleNext,
    alertTitle,
    firstName,
    birthDate,
    isLoading,
    lastName,
    navigate,
    setEmail,
    email,
  } = useRegisterContext();

  useEffect(() => {
    setSelectedType("Corporate");
  }, []);

  const handleShowTermsConditions = () => {
    setShowTermsConditionModal(true);
    setShowMemberConsentModal(false);
  };

  const handleShowPrivacyNotice = () => {
    setShowPrivacyNoticeModal(true);
    setShowTermsConditionModal(false);
  };

  const handleShowMemberConsent = () => setShowMemberConsentModal(true);

  const toggleModal = (modal) => {
    setShowTermsConditionModal(modal === "terms");
    setShowPrivacyNoticeModal(modal === "privacy");
  };

  const handleClose = () => {
    setDisplayMemberExist(false);
    setShowTermsConditionModal(false);
    setShowPrivacyNoticeModal(false);
    setShowMemberConsentModal(false);
  };

  const handleCloseError = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
  };

  const handleMiddleNameCheckboxChange = () => {
    setIsMiddleNameChecked(!isMiddleNameChecked);
    if (!isMiddleNameChecked) {
      setMiddleName("");
    }
  };

  const handleBack = () => {
    setMemberConsentChecked(false);
    setIsMiddleNameChecked(false);
    setTermsChecked(false);
    navigate(-1);
    resetConfig();
  };

  const handleBirthdate = (date) => {
    setBirthDate(dayjs(date).format("MM/DD/YYYY"));
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  function isActivateDisabled() {
    return (
      isLoading || !isCorporateValid() || !termsChecked || !memberConsentChecked
    );
  }

  function getActivateClassname() {
    if (
      isLoading ||
      !isCorporateValid() ||
      !termsChecked ||
      !memberConsentChecked
    ) {
      return "bg-[#F6F7F7] text-[#A3A7AB]";
    } else {
      return "text-white";
    }
  }

  let isFieldDisabled = alertMessage === "Activate initialization was unsuccessful. Please refresh the page.";

  return (
    <React.Fragment>
      <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
        <div className="w-full sm:w-148 flex-grow">
          <div className="sm:w-full bg-white rounded-xl sm:my-12">
            <div className="w-full grid grid-cols-1 divide-y">
              <div className="p-4">
                <KeyboardArrowLeftIcon
                  className="absolute cursor-pointer"
                  onClick={handleBack}
                />

                <div className="text-center font-semibold text-[#1F2328]">
                  Activate Member Gateway Account
                </div>
              </div>
              <div className="p-4">
                <div className="text-[#60656D]">
                  Activate your Member Gateway Account with your details for
                  personalized healthcare benefits!
                </div>
                {!displayAlert && alertMessage !== "" && (
                  <span className="text-sm text-[#D32F2F]">{alertMessage}</span>
                )}
                <form onSubmit={handleNext}>
                  <div className="mt-2">
                    <div className="font-semibold">Company Code</div>
                    <div className="mt-1">
                      <InputField
                        disabled={isFieldDisabled}
                        type="text"
                        name="companyCode"
                        value={companyCode}
                        onChange={companyCodeValidation}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Employee ID</div>
                    <div className="mt-1">
                      <InputField
                        disabled={isFieldDisabled}
                        type="text"
                        name="employeeNumber"
                        value={employeeNumber}
                        onChange={employeeNumberValidation}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">First Name</div>
                    <div className="mt-1">
                      <InputField
                        disabled={isFieldDisabled}
                        type="text"
                        name="firstName"
                        value={firstName}
                        onChange={firstNameValidation}
                        maxLength={25}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Middle Name</div>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="middleName"
                        value={middleName}
                        disabled={isMiddleNameChecked || isFieldDisabled}
                        onChange={middleNameValidation}
                        maxLength={25}
                      />
                    </div>
                    <div className="flex flex-row mt-2">
                      <input
                        disabled={isFieldDisabled}
                        className="w-3"
                        type="checkbox"
                        id="includeMiddleName"
                        checked={isMiddleNameChecked}
                        onChange={handleMiddleNameCheckboxChange}
                      />
                      <div className="ml-1 text-xs text-[#A3A7AB]">
                        I don't have a middle name
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="flex flex-row">
                      <div className="w-full">
                        <div className=" font-semibold">Last Name</div>
                        <div className="w-full mt-1">
                          <InputField
                            disabled={isFieldDisabled}
                            type="text"
                            name="lastName"
                            value={lastName}
                            onChange={lastNameValidation}
                            maxLength={25}
                          />
                        </div>
                      </div>
                      <div className="ml-2">
                        <div id="suffix" className="font-semibold">
                          Suffix
                        </div>
                        <div className="mt-1">
                          <InputField
                            disabled={isFieldDisabled}
                            value={suffixName}
                            onChange={suffixValidation} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Date of Birth</div>
                    <div className="mt-1">
                      <DatePicker
                        disabled={isFieldDisabled}
                        name="birthDate"
                        disablePast={false}
                        value={birthDate ? dayjs(birthDate) : null}
                        onChange={handleBirthdate}
                        maxDate={dayjs().subtract(18, "years")}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Mobile Number</div>
                    <div className="mt-1">
                      <NumberField
                        disabled={isFieldDisabled}
                        name="mobileNumber"
                        type="text"
                        adornment="+63"
                        value={mobileNumber}
                        onChange={formatMobileNumber}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Email Address</div>
                    <div className="mt-1">
                      <InputField
                        disabled={isFieldDisabled}
                        type="text"
                        name="email"
                        value={email}
                        onChange={handleEmail}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="font-semibold">Confirm Email Address</div>
                    <div className="mt-1">
                      <InputField
                        disabled={isFieldDisabled}
                        type="text"
                        value={confirmEmailAddress}
                        onChange={(e) => setConfirmEmailAddress(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
                <div className="mt-5">
                  <div className="flex flex-row">
                    <div>
                      <input
                        disabled={isFieldDisabled}
                        type="checkbox"
                        checked={termsChecked}
                        className="h-5"
                        onChange={(e) => setTermsChecked(e.target.checked)}
                      />
                    </div>

                    <div className="text-sm ml-1">
                      I have carefully reviewed and understood the{" "}
                      <button
                        className="text-[#0947AB]"
                        onClick={handleShowTermsConditions}
                      >
                        Terms & Conditions
                      </button>{" "}
                      and{" "}
                      <button
                        className="text-[#0947AB]"
                        onClick={handleShowPrivacyNotice}
                      >
                        Privacy Policy
                      </button>
                      {/* */}.
                    </div>
                  </div>

                  <div className="flex flex-row">
                    <div>
                      <input
                        disabled={isFieldDisabled}
                        type="checkbox"
                        checked={memberConsentChecked}
                        className="h-5"
                        onChange={(e) => setMemberConsentChecked(e.target.checked)}
                      />
                    </div>

                    <div className=" text-sm ml-1">
                      I hereby agree to the terms outlined in the{" "}
                      <button
                        className="text-[#0947AB]"
                        onClick={handleShowMemberConsent}
                      >
                        Member Consent
                      </button>{" "}
                      agreement.
                    </div>
                  </div>
                </div>

                <div>
                  <div className="text-[#60656D] text-center">
                    You will receive an OTP via SMS when you activate
                  </div>

                  <div className="w-full sm:w-full grid justify-items-end mt-3">
                    <Button
                      disabled={isActivateDisabled()}
                      className={`w-full h-12 ${getActivateClassname()}`}
                      onClick={handleNext}
                    >
                      {isLoading ? <CircularProgress size={"1rem"} /> : "Activate"}
                    </Button>

                    <TermsConditionsModal
                      isOpen={showTermsConditionModal}
                      onClose={handleClose}
                      toggleModal={toggleModal}
                    />

                    <PrivacyNoticeModal
                      isOpen={showPrivacyNoticeModal}
                      onClose={handleClose}
                      toggleModal={toggleModal}
                    />

                    <MemberConsentModal
                      isOpen={showMemberConsentModal}
                      onClose={handleClose}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleCloseError}
      />
      <ErrorModal
        open={displayMemberExist}
        title={"Uh-Oh! Policy Already Used"}
        message={"Oops! This policy has already been activated."}
        onClose={handleClose}
      />
      <UpdateModal/>
    </React.Fragment>
  );
}

export default ActivateCorpCodeFlow;
